// ============================================================
// ANSICHTSSACHE-AGENT – Suchfelder ohne Autokorrektur
// ============================================================
// In ein Suchfeld tippt man Wortanfaenge, Namen und Nummern,
// keine Saetze. Safari auf Mac und iPhone hielt „Löw“ fuer
// einen Tippfehler, bot „Löwe“ an und ersetzte das Wort beim
// naechsten Leerzeichen — gesucht war dann etwas anderes.
//
// Jedes Suchfeld bekommt deshalb diese Attribute:
//   autoCorrect       Safari: kein Ersetzen beim Tippen
//   spellCheck        keine rote Wellenlinie; Safari auf dem Mac
//                     korrigiert nur, wo es auch prueft
//   autoCapitalize    iPhone: kein Grossbuchstabe am Anfang
//   autoComplete      keine Liste frueherer Eingaben des Browsers
//   writingsuggestions  macOS ab 14: kein grauer Wortvorschlag
//                     hinter dem Cursor (React kennt das Attribut
//                     noch nicht und reicht es klein geschrieben
//                     durch)
//
// `Input` setzt sie bei `type="search"` selbst; nackte
// `<input>`-Suchfelder holen sie mit `{...noAutocorrect}`. Der
// Test `no-autocorrect.test.ts` haelt fest, dass keines fehlt.
// ============================================================

export const noAutocorrect = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  writingsuggestions: "false",
} as const;
